import React from 'react'

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen bg-[#0a192f] flex justify-center items-center p-4 pt-8"
    >
      <form
        method="POST"
        action="https://getform.io/f/6066f06d-1ba4-4a5e-8100-cb6e02bf2147"
        className="flex flex-col max-w-[600px] w-full"
      >
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-orange-700 text-gray-300">
            Contact
          </p>
          <p className="text-gray-300 py-4">
            Kirimkan formulir di bawah ini atau kirimi saya email -
            jaya.arlando@gmail.com
          </p>
        </div>
        <input
          className="bg-[#ccd6f6] p-2"
          type="text"
          placeholder="Name"
          name="name"
        />
        <input
          className="my-4 p-2 bg-[#ccd6f6]"
          type="email"
          placeholder="Email"
          name="email"
        />
        <textarea
          className="bg-[#ccd6f6] p-2"
          name="message"
          rows="10"
          placeholder="Message"
        ></textarea>
        <button className="text-white border-2 hover:bg-orange-700 hover:border-orange-700 px-4 py-3 my-8 mx-auto flex items-center">
          Kirim
        </button>
      </form>
    </div>
  )
}

export default Contact
